// extracted by mini-css-extract-plugin
module.exports = {"adminSidebar":"AdminSidebar_adminSidebar__1sY1e","menuBlock":"AdminSidebar_menuBlock__Q0bmZ","open":"AdminSidebar_open__14uVZ","dark":"AdminSidebar_dark__2cp4R"};